import { useEffect, useState, useMemo } from 'react';
import { RevealOnScroll } from './RevealOnScroll';

export const ParticipanList = (props) => {
  const [search, setSearch] = useState('');
  const handleSearchChange = (e) => setSearch(e.target.value);

  const shownParticipants = useMemo(() =>
    (search && props.participants)
        ? props.participants.filter(x =>
            search
                .toLowerCase()
                .split(/[ ,&]/g)
                .filter(x => x.length !== 0 && x !== "og")
                .every(s => x.groupName.toLowerCase().includes(s)))
        : props.participants, 
    [props.participants, search]);

  return props.participants === undefined ? (
    <div className="flex flex-col h-full justify-center items-center">
        <div class="border-gray-300 md:h-20 md:w-20 animate-spin rounded-full border-8 border-t-slate-800" />
    </div>
  ) : (
    <>
      <div className="md:h-1/4"></div>
      <RevealOnScroll extraClasses={"delay-300"}>
        <p className="md:text-4xl font-serif italic">Find dig / jer i listen her under</p>
      </RevealOnScroll>
      <RevealOnScroll extraClasses={"delay-500 bg-gray-100 shadow md:rounded-lg p-3 items-center w-full  max-w-[34rem]"}>
      <label className="flex space-x-2">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke-width="1.5"
          stroke="currentColor"
          className="w-6 h-6"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z"
          />
        </svg>

        <input
          type="text"
          value={search} onChange={handleSearchChange}
          placeholder="Navn"
          className="md:text-2xl font-serif bg-transparent w-full focus:outline-none"
        ></input>
      </label>
      </RevealOnScroll>
      <RevealOnScroll extraClasses={"delay-700 grow overflow-y-auto flex flex-col flex-auto w-full items-center md:px-1 space-y-2 italic"}>
        {
            [...shownParticipants]
            .sort((a, b) => a.groupName.localeCompare(b.groupName))
            .map(p => 
                <div key={p.id} className="bg-gray-50 p-2 w-full max-w-[34rem] shadow md:rounded-xl" onClick={() => props.selectGroup(p.id)}>
                    <p className="md:text-2xl font-serif">{p.groupName}</p>
                </div>)
        }
      </RevealOnScroll>
    </>
  );
};
